module.exports = __webpack_public_path__ + "static/sound/results.e615d43aa.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/music/results.mp3
// module id = 604
// module chunks = 1